<template>
  <ModalBase :show-modal="true" @close-modal="close" short auto-h class="gk-modal-confirm">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal title-modal--simple">
        <template v-slot:title>
          {{ $gettext('Payment Link') }}
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>
      <p v-translate>
        You cannot send payment links without a completed Mollie account. Please <span class="emphasize">update the information in your Mollie account</span>. Once you have done this, you can start sending payment links with you invoice.
      </p>
    </template>
    <template v-slot:actions>
      <GekkoButton
        @click="close()"
        :text="$gettext('Cancel')"
        variant="light"
        class="mr-2"
      />
      <GekkoButton
        href="https://www.mollie.com/dashboard/onboarding/organization-details"
        :text="$gettext('Update mollie information')"
      />
    </template>
  </ModalBase>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import ModalBase from "@/components/base_components/ModalBase";

export default {
  name: 'MollieMissingDataModal',
  components: {
    TitleBar,
    GekkoButton,
    ModalBase,
  },
  methods: {
    close () {
      this.$emit('close')
    },
    connectToMollie () {
      console.log('connectToMollie')
    }
  },
}
</script>

<style lang="scss" scoped>

</style>